export function isFuncState<S>(action: React.SetStateAction<S>): action is (prev: S) => S {
  return typeof action === "function";
}
